<template>
    <div>
        <div
            v-if="process && !message"
            class="col-12 d-flex fixed-top justify-content-center align-items-center message--top"
        >
            <span>Een moment geduld, je gegevens worden opgeslagen...</span>
        </div>
        <div
            v-if="message && !process"
            class="col-12 d-flex fixed-top justify-content-center align-items-center message--top"
        >
            <span>
                <i v-if="!type" class="fas fa-check"></i>
                {{ message }}
                <i
                    v-if="type"
                    class="fas fa-spinner fa-spin fa-lg ml-1 color--purple"
                ></i>
            </span>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        message: {
            type: String,
            default: ''
        },
        process: {
            type: Boolean,
            default: false
        },
        type: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {};
    }
};
</script>
